import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Radio, Space, Input, Row, Checkbox } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import "./location.filter.css";
import axios from "axios";
import {
  fetchKeySearchLocation,
  searchLocation,
  fetchRegionSuggestionsInit,
  fetchKeySearchDynamicLocation,
  fetchKeySearchCompanyAndIndustries,
} from "../../../../redux/actions";
import { debounce } from "../../../../shared/helpers";
import { useParams } from "react-router-dom";

const FilterIndustry = (props) => {
  const dispatch = useDispatch();
  const { id, name } = useParams();
  const [industryValue, setIndustryValue] = useState([]);
  const [defaultValue, setDefaultValue] = useState();

  const [searchtext, setSearch] = useState();
  const industries = useSelector(
    (state) => state.searchSkillListingReducer.industries
  );
  const [text, setText] = useState("");
  const industryCount = localStorage.getItem("industryCount");

  function removeDuplicatesByValue(data) {
    const uniqueValues = new Set();
    const filteredData = [];

    for (const obj of data) {
      if (!uniqueValues.has(obj.value)) {
        uniqueValues.add(obj.value);
        filteredData.push(obj);
      }
    }

    return filteredData;
  }

  useEffect(() => {
    if (props.industryObj) {
      setDefaultValue(props.industryObj);
    }
  }, [props]);

  useEffect(() => {
    var options = [];
    if (industries && industries?.result) {
      
        options = industries?.result?.orgDetails?.industries.map((el=>(
          {
            value: el?._id,
            count: el?.count,
          }
        )))
        if (props.check && props.check.length > 0) {
          for (let j = 0; j < props.check.length; j++) {
             options = [
                {
                   value: props.check[j].name,
                   value2: props.check[j].id,
                   count: props.check[j].count

                },
                ...options,
             ];
          }
       }
       var uniqueArr = [];
       options.forEach(option => {
          if (!uniqueArr.some(item => item.value === option.value)) {
             uniqueArr.push(option);
          }
       });
       setIndustryValue(uniqueArr.sort((a, b) => a?.value?.toLowerCase()?.localeCompare(b?.value?.toLowerCase())));
      
    }
  }, [industries]);

  useEffect(() => {
    var options = [];
    if (industries?.length > 0) {
      for (
        var i = 0;
        i < industries?.result?.orgDetails?.industries?.length;
        i++
      ) {
        options = [
          ...options,
          {
            value: industries?.result?.orgDetails?.industries?.[i]?._id,
            count: industries?.result?.orgDetails?.industries?.[i]?.count,
          },
        ];
      }
      setIndustryValue(options);
    }
  }, [industries]);

  const onChange = (e) => {
    e.preventDefault();
    try {
      if (e.target.checked) {
        props.setCheckIndustryId((prev) => [...prev, e.target.value]);

        props.setcheck((prev) => [
          ...(prev || []),
          {
            name: e.target.value,
            id: e.target.value,
            count: parseInt(e.target?.count) || 0,
          },
        ]);
      } else {
        props.setCheckIndustryId(
          props?.checkIndustryId
            .map((v) => v.replace(/\+/g, " "))
            .filter((item) => item !== e.target.value)
        );
        props.setcheck(
          props?.check.filter((item) => {
            return item.id !== e.target.value && item.ids !== e.target.value;
          })
        );
      }
    } catch (error) {
      console.warn("error", error);
    }
    if (props.mobileFilter) {
      props.setVisible(false);
    }
  };

  const onLocationSearch = (value) => {
    props.setEmptyIndustryInput(value);
    let params = {};
    setText(value);
    if (Object.keys(props?.searchLocationFilter)?.length) {
      const query = `industry=${value}`;
      params = {
        value: query,
        body: props.searchLocationFilter,
      };
      dispatch(fetchKeySearchCompanyAndIndustries(params));
    } else {
      const obj = {
        value: value,
        type: "industry",
      };
      params = { obj };
    }
    dispatch(fetchKeySearchCompanyAndIndustries(params));
  };

  const getCheckedValues = (value) => {
    if (
      props.checkIndustryId?.map((v) => v.replace(/\+/g, " ")).includes(value)
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className="location-suggestion-view">
      <Input
        onChange={(e) => onLocationSearch(e.target.value)}
        // onChange={debounce((e) => onLocationSearch(e.target.value))}
        className="filter-search-input"
        placeholder="Search"
        value={props.emptyIndustryInput}
        prefix={<SearchOutlined />}
      />
      <Radio.Group
        onChange={onChange}
        className="location-radios-grp radio-color"
        // here
        value={props?.check}
      >
        <Space
          direction="vertical"
          className={"infinite-scroller mobile-no-scroller"}
          style={{ overflow: "auto", width: "100%" }}
        >
          {!searchtext ? (
            <div
              className={`location-lists-container ${
                industryValue?.length > 5 ? "show-scrollbar" : ""
              }`}
            >
              {industryValue.map((items, index) => {
                return items?.value ? (
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      marginTop: index == 0 ? "0px" : "10px",
                    }}
                    key={index}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "inherit",
                      }}
                    >
                      {/* <Radio */}
                      <Checkbox
                        key={index}
                        value={items.value}
                        value2={items?.count}
                        className="location-radio"
                        onChange={onChange}
                        checked={getCheckedValues(items.value)}
                        // checked={
                        //   props?.check
                        //     ? items?.value == props?.check
                        //     : items?.value == props?.check
                        // }
                      >
                        <div
                          style={{
                            display: "flex",
                            width: "inherit",
                            justifyContent: "space-between",
                          }}
                        >
                          <div>{items?.value}</div>
                          {/* {props?.fromCandMkt || id ? null : <> <div>({items?.count})</div> </>} */}
                        </div>
                      </Checkbox>
                      {/* </Radio> */}
                    </div>
                  </div>
                ) : null;
              })}
            </div>
          ) : (
            searchtext.map((items, index) => {
              return (
                <Radio
                  key={index}
                  value={defaultValue ? defaultValue : JSON.stringify(items)}
                  className="location-radio"
                  //  onChange={onChange}
                  // checked={items?.value == props?.regionObj}
                  checked={
                    props?.regionObj?.value
                      ? items?.value == props?.regionObj?.value
                      : items?.value == props?.regionObj
                  }
                >
                  {items.value}
                </Radio>
              );
            })
          )}
        </Space>
      </Radio.Group>
    </div>
  );
};
export default FilterIndustry;
